import { useCallback, useState, useEffect } from 'react';

import { useIsEditorToolbarDockedAtTop } from '@confluence/content-types-header';

import {
	getBannerType,
	persistBannerDismissalNewPinning,
	isBannerDismissedInLocalStorageNewPinning,
} from '../EditorControlsBannerDismissal';

export const useIsControlsBannerDismissed = (isLivePage: boolean) => {
	const isEditorToolbarDockedAtTop = useIsEditorToolbarDockedAtTop({
		defaultDockedAtTop: !isLivePage,
	});

	const bannerType = getBannerType(isEditorToolbarDockedAtTop);

	const [isControlsBannerDismissed, setIsControlsBannerDismissed] = useState(() =>
		isBannerDismissedInLocalStorageNewPinning(bannerType),
	);

	useEffect(() => {
		setIsControlsBannerDismissed(isBannerDismissedInLocalStorageNewPinning(bannerType));
	}, [bannerType]);

	const onDismiss = useCallback(() => {
		setIsControlsBannerDismissed(true);
		persistBannerDismissalNewPinning(bannerType);
	}, [bannerType]);

	return { isControlsBannerDismissed, onDismiss, bannerType };
};
